import superMeta from '../_AR_CAT/metaArCatNode.mjs'

export default {
    ...superMeta,
    name: '输入参数',
    textProp: 'algTitle',
    type: 'UI_INPUT',
}
